import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/how-to-repay/gcash-step2.png")